import { useEffect, useState } from 'react'
import { Button, Form, Header, Modal } from 'semantic-ui-react'

import { AgencyService, AreaService } from '../services'

import { FeedbackMessage } from '../constants'

import { ErrorMessage } from './error-message'

import { Agency, Area } from '../models'

import { LoadingSpinner } from './loading-spinner'


export function AgencyCreateForm({ setCreateModalVisible, addAgencyToList }: { setCreateModalVisible: Function, addAgencyToList: Function }) {

    const [creating, setCreating] = useState(false)
    const [agencyName, setAgencyName] = useState<string>('')
    const [agencyAreaId, setAgencyAreaId] = useState<number>()
    const [existingAreas, setExistingAreas] = useState<Area[]>([])
    const [errorFetchingAreas, setErrorFetchingAreas] = useState(false)
    const [agencyCreationError, setAgencyCreationError] = useState(false)
    const [loadingAreas, setLoadingAreas] = useState<boolean>(true)


    useEffect(() => fetchExistingAreas(), [])

    const fetchExistingAreas = () => {

        AreaService.getAreaList('sup')
            .then(data => {
                setExistingAreas(data)
                setLoadingAreas(false)
            })
            .catch(err => {
                console.log(err)
                setErrorFetchingAreas(true)
            })
            .finally(() => setLoadingAreas(false))
    }

    const buildAreaDropdown = (areas: Area[]) => {

        return areas.map(a => {

            return {
                text: a.city,
                value: a.id
            }
        })
    }


    const handleFormSubmit = () => {

        setCreating(true)

        const agency = new Agency({ name: agencyName, area: new Area({ id: agencyAreaId }) })

        AgencyService.createAgency(agency, 'sup')
            .then(agency => {
                addAgencyToList(agency)
                setCreateModalVisible(false)
            })
            .catch(__ => setAgencyCreationError(true))
            .finally(() => setCreating(false))
    }

    return <Modal
        size='tiny'
        onClose={() => setCreateModalVisible(false)}
        onOpen={() => setCreateModalVisible(true)}
        open={true}>
        <Modal.Content >
            {loadingAreas && <LoadingSpinner />}
            {!loadingAreas &&
                <Modal.Description>
                    <Header as="h3">Nouvelle agence</Header>
                    {agencyCreationError && <ErrorMessage errorText={FeedbackMessage.AGENCY_CREATE_ERROR} />}
                    {errorFetchingAreas && <ErrorMessage errorText={FeedbackMessage.AREA_FETCH_ERROR} />}
                    <br />
                    {!errorFetchingAreas &&
                        <Form>

                            <Form.Select
                                fluid
                                label='Ville'
                                options={buildAreaDropdown(existingAreas)}
                                placeholder='Choisir une zone'
                                value={agencyAreaId}
                                onChange={(e: any, d: any) => setAgencyAreaId(d.value)}
                            />

                            <Form.Input
                                fluid
                                label='Nom'
                                placeholder="Nom de l'agence"
                                value={agencyName}
                                onChange={(e: any) => setAgencyName(e.target.value)} />
                        </Form>}
                    <br />
                </Modal.Description>
            }
        </Modal.Content>
        <Modal.Actions>
            <Button color='black' onClick={() => setCreateModalVisible(false)}>Annuler</Button>
            <Button color='orange' content="Confirmer" onClick={handleFormSubmit} loading={creating} disabled={errorFetchingAreas}/>
        </Modal.Actions>
    </Modal>
}